var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length
    ? _c(
        "div",
        { staticClass: "product-markers" },
        _vm._l(_vm.list, function(m, i) {
          return _c(
            "div",
            { key: i, class: "product-markers-" + m.type, style: m.styles },
            [_vm._v("\n    " + _vm._s(m.text) + "\n  ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }